// @ts-nocheck
import { useState, useEffect } from 'react';
import axios from 'axios'
import { PrimaryColor, SERVER_IP } from '../../variables';
import { Box, Paper } from '@mui/material';
import TablePlaceholder from '../TablePlaceholder';
import { ToastContainer, toast } from "react-toastify";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MuiTextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import {
    Grid,
    Button,
    CircularProgress,
} from "@material-ui/core";
import moment from 'moment'
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import jsPDF from 'jspdf'
import 'jspdf-autotable'
import logo from "../../assert/logo_index.jpeg"
import { useNavigate } from 'react-router-dom';
import { checkIfMonthOver, getCurrentUserID, isLoggedUserStaff, isProgClaimEligible, isSuperUser } from '../../utils';
import SignaturePad from './SignaturePad';

export default function ViewSDPCReports() {

    const navigate = useNavigate();

    const [reports, setReports] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState<any>({});
    const [addButtonClicked, setAddButtonClicked] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState<Date | null>(new Date());
    const [another, setAnother] = useState<Date | null>(new Date());

    const isStaff = isLoggedUserStaff()

    const fetchReports = () => {
        setLoading(true)
        axios
            .get(`${SERVER_IP}reportSDPC/get?ContactID=${getCurrentUserID()}&Staff=${isStaff}&month=${moment(selectedMonth).format("MM")}&year=${moment(selectedMonth).format("YYYY")}`)
            .then((res) => {
                let t = res.data.data?.map((d, index) => {
                    return {
                        ...d,
                        S_No: index + 1
                    }
                })
                console.log(t)
                setReports(t);
                setReportData(res.data)
            })
            .catch((err) => {
                console.log(err)
                toast.error("Couldn't fetch SDPC Reports!");
            }).finally(() => {
                setLoading(false)
            })
    };


    const columns: GridColDef[] = [
        {
            field: 'SiteName',
            headerName: 'Site',
            width: 200,
        },
        {
            field: 'UnitRate_Mosquito',
            headerName: 'Mosquito Control Rate',
            description: 'Mosquito Control Rate',
            width: 120,
        },
        {
            field: 'UnitRate_Termite',
            headerName: 'Termite Control Rate',
            description: 'Termite Control Rate',
            width: 120,
        },
        {
            field: 'UnitRate_Pest',
            headerName: 'Common Pest Rate',
            description: 'Common Pest Rate',
            width: 120,
        },
        {
            field: 'Deduction_A',
            headerName: 'Mosquito Control, Termite Control & Common Pest Deduction (A)',
            description: 'Mosquito Control, Termite Control & Common Pest Deduction (A)',
            width: 120,
        },
        {
            field: 'Deduction_B',
            headerName: 'Deliverable Deduction (B)',
            description: 'Deliverable Deduction (B)',
            width: 120,
        },
        {
            field: 'Deduction_C',
            headerName: 'Pest Control Audit Deduction (C)',
            description: 'Pest Control Audit Deduction (C)',
            width: 120,
        },
        {
            field: 'Deduction_Total',
            headerName: 'Total Deduction (A+B+C)',
            description: 'Total Deduction (A+B+C)',
            width: 150,
        },
        {
            field: 'Report_Month',
            headerName: 'Reported On',
            width: 100
        },
        {
            field: 'Action',
            headerName: 'Action Buttons',
            sortable: false,
            filterable: false,
            disableExport: true,
            width: 200,
            hide: !isSuperUser() || reportData.isAuthorized,
            renderCell: (row) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Button onClick={(e) => {
                            navigate('/UpdateSDPCReport', {
                                state: row.row,
                            });
                            e.stopPropagation()
                        }} color='primary' variant='contained'>Edit</Button>
                    </div>
                )
            }
        },

    ];

    const exportData = () => {

        const doc = new jsPDF("landscape")

        function addFooters() {
            const pageCount = doc.internal.getNumberOfPages();
            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.addImage(logo, 'jpeg', 10, 0, 80, 12)
                doc.text(docRefNo, width - 10, 10, { align: 'right' });
                doc.text(`Pest-Pro Management Pte. Ltd.`, 5, height - 5);
                doc.text(`Page ${i}`, width - 20, height - 5);
            }
        }

        const col = [
            { title: "S/N", field: "S_No" },
            { title: "Site", field: "SiteName" },
            { title: "Mosquito Control Rate", field: "UnitRate_Mosquito" },
            { title: "Termite Control Rate", field: "UnitRate_Termite" },
            { title: "Common Pest Rate", field: "UnitRate_Pest" },
            { title: "Mosquito Control, Termite Control & Common Pest Deduction (A)", field: "Deduction_A" },
            { title: "Deliverable Deduction (B)", field: "Deduction_B" },
            { title: "Pest Control Audit Deduction (C)", field: "Deduction_C" },
            { title: "Total Deduction (A+B+C)", field: "Deduction_Total" },
            // { title: "Reported On", field: "Report_Month" },
        ]

        doc.autoTable({
            theme: "grid",
            startY: 35,
            columns: col.map(col => ({ ...col, dataKey: col.field })),
            body: reports,
            styles: {
                halign: 'left',
                border: '2px solid',
                valign: 'middle'
            },
            headStyles: {
                halign: 'center',
                fillColor: PrimaryColor,
                lineColor: [0, 0, 0],
                border: '2px solid'
            },
            columnStyles: {
                1: { cellWidth: 50 },
                2: { cellWidth: 30 },
                3: { cellWidth: 30 },
                4: { cellWidth: 30 },
                5: { cellWidth: 30 },
                6: { cellWidth: 30 },
                7: { cellWidth: 30 }
            },
        })

        let month = moment(selectedMonth).format("MMMM YYYY")

        const docRefNo = `SDPC-${moment(selectedMonth).format("YYYYMM")}`

        doc.text(`SDPC Report - ${month}`, 110, 25)


        var width = doc.internal.pageSize.getWidth()
        var height = doc.internal.pageSize.getHeight()

        let finalY = doc.lastAutoTable.finalY + 10; // The y position on the page

        if (finalY > height - 30) {
            doc.addPage()
            finalY = 30;
        }

        doc.setFontSize(10).text(20, finalY, "Acknowledged By")
        finalY = finalY + 5
        doc.addImage(reportData.authImageUrl, 'jpeg', 20, finalY, 80, 15)
        // doc.line(20, finalY, 80, finalY);
        finalY = finalY + 20
        doc.setFontSize(15).text(20, finalY, reportData?.SignedBy || "")
        finalY = finalY + 5
        doc.setFontSize(10).text(20, finalY, `Date : ${moment(new Date()).format("DD/MM/YYYY")}`)

        finalY = finalY + 5


        doc.text("Pest-Pro Management Pte. Ltd.", width / 2, finalY, { align: 'center' })
        finalY = finalY + 5
        doc.text("3A International Business Park,#11-05 ICON@IBP,", width / 2, finalY, { align: 'center' })
        finalY = finalY + 5
        doc.text("Singapore 609935", width / 2, finalY, { align: 'center' })
        addFooters()
        doc.save(`${docRefNo}.pdf`)
    }

    useEffect(() => {
        // document.getElementById("ppp")?.click()
    }, [])

    const handleModalClose = () => {
        setAddButtonClicked(false)
    }

    return (

        <Box>

            <div style={{ padding: '10px 20px', maxWidth: '90%' }}>
                <Paper style={{ borderRadius: '10px', maxWidth: 'inherit' }}>
                    <Grid container spacing={3} style={{ padding: '10px' }}>

                        <Grid item xs={12} sm={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Month"
                                    views={['month', 'year']}
                                    value={selectedMonth}
                                    onChange={(newValue) => {
                                        setSelectedMonth(newValue)
                                    }}
                                    renderInput={(params) => <MuiTextField
                                        variant="outlined"
                                        id="selectedMonth"
                                        name="selectedMonth"
                                        fullWidth
                                        {...params} />
                                    }
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                style={{ marginTop: 10 }}
                                disabled={loading}
                                color="primary"
                                size="large"
                                variant="contained"
                                onClick={() => fetchReports()}
                            >
                                {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                                {"Get Reports"}
                            </Button>
                        </Grid>

                    </Grid>
                </Paper>

                <Paper style={{ borderRadius: '10px', marginTop: '30px', width: '100%', overflowX: 'auto' }}>
                    {(loading) ?
                        <TablePlaceholder />
                        :
                        reports?.length > 0 ?
                            <Grid container>
                                <Grid item xs={12}>
                                    <Toolbar
                                        sx={{
                                            pl: { sm: 2 },
                                            pr: { xs: 1, sm: 1 },
                                            backgroundColor: '#d9dffd',
                                        }}
                                    >
                                        <Typography
                                            sx={{ flex: '1 1 100%' }}
                                            variant="h6"
                                            id="tableTitle"
                                            component="div"
                                        >
                                            Summary Of SDPC Reports - {moment(selectedMonth).format('MMMM YYYY')}
                                        </Typography>
                                        <Typography
                                            sx={{ marginLeft: 'auto' }}
                                        >
                                            <Button id="ppp" color="primary" variant='contained' onClick={() => exportData()}>Export</Button>

                                        </Typography>
                                    </Toolbar>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: '100%', marginBottom: 10, marginLeft: 'auto', marginRight: 'auto' }}>
                                        <Box
                                            sx={{
                                                width: 1,
                                                '& .MuiDataGrid-columnHeaders': {
                                                    backgroundColor: PrimaryColor,
                                                },
                                                '& .red': {
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    fontWeight: '600',
                                                },
                                                '& .lightgreen': {
                                                    backgroundColor: 'yellow',
                                                    color: 'white',
                                                    fontWeight: '600',
                                                },
                                            }}
                                        >
                                            <DataGrid
                                                getRowId={(row) => row.ReportSDPCID}
                                                rows={reports}
                                                columns={columns}
                                                pageSize={5}
                                                loading={loading}
                                                autoHeight
                                                rowsPerPageOptions={[5]}
                                            />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6}>

                                </Grid>
                                <Grid style={{ textAlign: 'center', margin: 'auto' }} item sm={12} md={6}>
                                    {
                                        !!reportData.authImageUrl &&
                                        <div>
                                            <img
                                                src={reportData.authImageUrl}
                                                alt="Sign"
                                                width="80%"
                                            />
                                            <div style={{ textAlign: 'center', margin: 'auto', fontSize: 26, fontWeight: 'bold', paddingBottom: 10 }}>Signed By : {reportData.SignedBy}</div>
                                        </div>

                                    }
                                    {
                                        !isStaff && !!!reportData.isAuthorized &&
                                        checkIfMonthOver(another) && isProgClaimEligible() &&
                                        <Button
                                            color="primary"
                                            variant='contained'
                                            onClick={() => {
                                                setAddButtonClicked(true)
                                            }}
                                        >
                                            {"Authorize"}
                                        </Button>
                                    }
                                </Grid>
                            </Grid>
                            :
                            <h2 style={{ textAlign: 'center' }}>No Data Matches</h2>
                    }

                </Paper>
                <SignaturePad
                    show={addButtonClicked}
                    handleClose={() => handleModalClose()}
                    selectedMonth={selectedMonth}
                    fetchReports={() => fetchReports()}
                    reportType="SDPC"
                />
            </div>

            <ToastContainer />
        </Box>

    );
}
